import { makeStyles, Typography} from '@material-ui/core';
import React, {ReactNode} from 'react';

interface CardFieldStyles {
  name: string;
  value: string;
}

export type CardFieldProps = {
  name: string;
  value: ReactNode;
  ddprivacy?: string;
  styles?: Partial<CardFieldStyles>;
};

const useCardFieldStyles = makeStyles(() => ({
  fieldName: {
    fontSize: '0.875rem',
    marginBottom: '.45rem',
  },
  fieldValue: {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#2f3847',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
  },
}));

export const CardFieldV2 = (props: CardFieldProps) => {
  const classes = useCardFieldStyles();
  const {styles, name, value, ddprivacy} = props;
  return (
    <Typography component="div">
      <Typography className={`${classes.fieldName} ${styles?.name ?? ''}`}>{name}</Typography>
      <div className={`${classes.fieldValue} ${styles?.value ?? ''}`} data-dd-privacy={ddprivacy ?? 'allow'}>
        <Typography className={`${classes.fieldValue} ${styles?.value ?? ''}`}>{value}</Typography>
      </div>
    </Typography>
  );
};
